<hau-form [formGroup]="form">
  <hau-form-field label="Name" cols="8" [validation]="form.validation.name">
    <input nbInput fullWidth formControlName="name">
  </hau-form-field>
  <hau-form-field label="Kategorie" cols="4" [validation]="form.validation.category">
    <input nbInput fullWidth formControlName="category" placeholder="z.B. Allgemein/Heizung">
  </hau-form-field>
  <hau-form-field label="Beschreibung" [validation]="form.validation.description">
    <textarea nbInput fullWidth formControlName="description"></textarea>
  </hau-form-field>
  <hau-form-field label="Felddefinition" [validation]="form.validation.composition" [required]="true">
    <wr-custom-field-composition-control formControlName="composition"></wr-custom-field-composition-control>
  </hau-form-field>
</hau-form>
